const AppMedicalRecords =()=> import('./medical-records.vue');
import { guardRoute } from '../guardRouter';

import localeEn from '../../locales/en'
import localeAr from '../../locales/ar'
//pages
const PatientMedicalRecords = () => import('./patient-medical-records/patient-medical-records.vue');
const PatientMerge = () => import('./patient-medical-records/patient-merge/patient-merge.vue');
const NewPatientMerge = () => import('./patient-medical-records/new-patient-merge/new-patient-merge.vue');


export const translation = {
    en: {
        ...localeEn
    },
    ar: {
        ...localeAr
    }
}
const lang = localStorage.getItem('NG_TRANSLATE_LANG_KEY');

const medicalRecordsRoutes = [
    {
        path: '/medical-records',
        name: '/medical-records',
        component: AppMedicalRecords,
        meta: {
            title: translation[lang].Nav.MedicalRecord.MedicalRecord,
        },
        children: [
            //patient-merge
            {
                path: 'patient-medical-records',
                name: '/medical-records/patient-medical-records',
                meta: {
                    title: translation[lang].Nav.MedicalRecord.PatientMedicalRecords,
                },
                component: PatientMedicalRecords,
                children: [
                    {
                        path: 'new-patient-merge',
                        name: '/medical-records/patient-medical-records/new-patient-merge',
                        meta: {
                            title: translation[lang].Nav.MedicalRecord.NewPatientMerge,
                        },
                        component: NewPatientMerge,                      
                    },
                    {
                        path: '/medical-records/patient-medical-records/patient-merge',
                        name: '/medical-records/patient-medical-records/patient-merge',
                        meta: {
                            title: translation[lang].Nav.MedicalRecord.PatientMerge,
                           // hide: true
                        },

                        component: PatientMerge
                    }
                ]
            },

        ],
        beforeEnter: guardRoute
    }
];

export default medicalRecordsRoutes;
